'use client';

import { Stack } from '@mui/material';
import { useEffect, useRef } from 'react';

import DiscordModal, { type DiscordModalHandle } from '@/components/bases/DiscordModal';
import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';

interface LayoutProps {
  children: React.ReactNode;
}

function Layout({ children }: LayoutProps) {
  const discordModalRef = useRef<DiscordModalHandle>(null);

  useEffect(() => {
    const isDiscordModal = sessionStorage.getItem('discordModal');
    if (!isDiscordModal) {
      discordModalRef.current?.show();
    }
  }, [discordModalRef.current]);

  return (
    <Stack width={'100%'} height={'100%'} component={'main'}>
      <Header />
      <DiscordModal ref={discordModalRef} />
      {children}
      <Footer />
    </Stack>
  );
}

export default Layout;
